import api from '../config/api';

export const getProjectInterestContent = id => api.get(`/projects/${id}/may_interest`);
